module.exports = __webpack_public_path__ + "static/media/ranman.baf5a06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/ranman.png
// module id = 2113
// module chunks = 3